module.exports = __webpack_public_path__ + "img/floating_arms_skull_2020-11-01.a597f0c6.jpg";